import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'eui-page-columns',
    templateUrl: './eui-page-columns.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiPageColumnsComponent {

    @HostBinding() class = 'eui-page-columns';

    constructor(
    ) {}
}
